<template>
  <div>
    <v-img
      :src="member.coverPicture"
      class="primary darken-2"
      height="256px" />

    <v-layout column>
      <v-avatar :size="avatarSize" class="mx-auto" :style="`margin-top: -${avatarSize / 2}px;`">
        <v-img
          :src="member.profilePicture"
          class="primary" />
      </v-avatar>
      <h1 class="display-1 mx-auto my-5">{{ name(member) }}</h1>
    </v-layout>
  </div>
</template>

<script>
import FbMemberMixin from '../mixins/fb-member'

export default {
  name: 'FbMemberHeader',
  mixins: [FbMemberMixin],
  props: {
    type: String,
    member: Object
  },
  data() {
    return {
      avatarSize: 180
    }
  }
}
</script>
